import loadable from '@loadable/component';

export const MoneyweekSiteWrapper = loadable(
  () => import(/* webpackChunkName: "moneyweek-site" */ './MoneyweekSiteWrapper'),
);
